import { brandString } from "./brand-string"
import { AType } from "@silversea-ssc/functional-support"
import { v4 as uuidv4 } from "uuid"
import * as t from "io-ts"
import { brandFromPredicate } from "./brand-from-predicate"

const uuidRegex = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/i
const IoTsUUID = /* @__PURE__ */ brandFromPredicate(t.string, (x) => uuidRegex.test(x), "UUID")

export const UUID = /* @__PURE__ */ brandString(IoTsUUID, ({ uuid }) => uuid())
export type UUID = AType<typeof UUID>

const _new = (): UUID => uuidv4() as UUID

export { _new as new }
